import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "/publicatie/";

const PublicatieApi = {
	get(tochtId) {
		const serviceUrl = prependRoot(routePrefix + tochtId, getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				accept: "application/json"
			}
		});
	},

	save(model) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return axios.put(
			serviceUrl,
			model,
			{
				headers: {
					accept: "application/json"
				}
			}
		);
	}
};

export default PublicatieApi;
